/**
 * Horizontal carousel: arrow navigation + pointer drag.
 * Works on any scrollable flex track. Used by the forme carousel and gallery.
 */

export function wireCarousel(
  track: HTMLElement,
  prev: HTMLButtonElement,
  next: HTMLButtonElement,
): { update: () => void } {
  const page = () => Math.max(140, track.clientWidth * 0.85);

  const update = () => {
    const max = track.scrollWidth - track.clientWidth - 1;
    prev.disabled = track.scrollLeft <= 0;
    next.disabled = track.scrollLeft >= max;
  };

  prev.addEventListener("click", () => track.scrollBy({ left: -page(), behavior: "smooth" }));
  next.addEventListener("click", () => track.scrollBy({ left: page(), behavior: "smooth" }));
  track.addEventListener("scroll", update, { passive: true });

  // Pointer drag — horizontal.
  let down = false;
  let startX = 0;
  let startScroll = 0;
  let moved = 0;

  track.addEventListener("pointerdown", (e) => {
    down = true;
    startX = e.clientX;
    startScroll = track.scrollLeft;
    moved = 0;
  });
  track.addEventListener("pointermove", (e) => {
    if (!down) return;
    const d = e.clientX - startX;
    moved = Math.max(moved, Math.abs(d));
    track.scrollLeft = startScroll - d;
  });
  const end = () => {
    down = false;
  };
  track.addEventListener("pointerup", end);
  track.addEventListener("pointercancel", end);
  window.addEventListener("pointerup", end);

  // A real drag should not also fire a tile click.
  track.addEventListener(
    "click",
    (e) => {
      if (moved > 8) {
        e.stopPropagation();
        e.preventDefault();
        moved = 0;
      }
    },
    true,
  );

  update();
  window.addEventListener("resize", update);
  return { update };
}
